import { Component, Input, inject } from "@angular/core";
import { BusyIndicatorComponent } from "@tylertech/common-components-module";
import { CommonDialogsService } from "@tylertech/common-dialogs-module";
import { UserProfileService } from "@tylertech/core-module";
import { ForgeAccordionModule, ForgeIconButtonModule, ForgeToolbarModule, ForgeTooltipModule } from "@tylertech/forge-angular";
import { AggregateCriteria } from "@tylertech/tyler-api-types";
import { AggregateManagerService } from "../../services";
import { AggregateCollectionComponent } from "./aggregateCollection.component";

@Component({
    selector: "tasks-list",
    templateUrl: "./tasks.tmpl.html",
    styleUrls: [
        "./tasks.component.scss"
    ],
    imports: [
        AggregateCollectionComponent,
        BusyIndicatorComponent,
        ForgeAccordionModule,
        ForgeIconButtonModule,
        ForgeToolbarModule,
        ForgeTooltipModule,
    ]
})
export class TasksComponent
{
    private readonly $userProfileService = inject(UserProfileService);
    private readonly $commonDialogsService = inject(CommonDialogsService);
    private readonly $aggregateManagerService = inject(AggregateManagerService);

    private hasTasks: boolean = false;

    @Input()
    header: string;

    get loaded(): boolean
    {
        return this.$aggregateManagerService.AggregatesLoaded;
    }

    get aggregateCriterias(): AggregateCriteria[]
    {
        return this.$aggregateManagerService.VisibleAggregateCriterias;
    }

    get showNoTasksMsg(): boolean
    {
        if (!this.hasTasks)
        {
            const shown = this.aggregateCriterias;
            this.hasTasks = shown && shown.length > 0;
        }
        return this.loaded && !this.hasTasks;
    }

    displayOrdering(): void
    {
        const originalVisible = [...this.$aggregateManagerService.VisibleAggregateCriterias];
        const originalHidden = [...this.$aggregateManagerService.HiddenAggregateCriterias];

        const groups = [
            this.$aggregateManagerService.VisibleAggregateCriterias,
            this.$aggregateManagerService.HiddenAggregateCriterias
        ];
        this.$commonDialogsService.showDragAndDropDialog(groups, "Title", "Application", "Dashboard Configuration", "Smart Cards", ["Visible", "Hidden"])
            .then(
                r =>
                {
                    if (r)
                        this.savePositionSettings(r);
                    else
                    {
                        this.$aggregateManagerService.VisibleAggregateCriterias = originalVisible;
                        this.$aggregateManagerService.HiddenAggregateCriterias = originalHidden;
                    }
                },
                _e =>
                {
                    location.reload();
                }
            );
    }

    savePositionSettings(groups: AggregateCriteria[][]): void
    {
        this.$userProfileService.SetPositions(groups);
    }
}
